<span class="close-modal-outside"><i (click)="ActiveModal.dismiss()" class="im-icon im-icon-x-light"></i></span>
<div class="modal-wrap">
  @if (!ready) {
    <app-spinner [centerVertically]="true"></app-spinner>
  }
  @if (toolkit) {
    <div class="d-flex detail-modal">
      <!-- start form -->
      <div class="d-flex flex-column w-100 flex-grow-1 scroll-y">
        @if (loading) {
          <div style="height: 100%;">
            <app-spinner [centerVertically]="true"></app-spinner>
          </div>
        }
        @if (!loading && ready) {
          <div class="">
            <!-- header -->
            <div class="detail-modal-header d-flex flex-row justify-content-between align-items-center" style="min-height: 36px;">
              <h1 style="min-height: 36px;">{{toolkit.title}} {{id ? toolkit.code : 'Nieuw toolkit artikel'}}</h1>
              @if (this.activeSection !== 'general') {
                <div class="h-100 d-flex align-items-center">
                  <!-- delete -->
                  @if (true) {
                    <div class="position-relative" appClickOutside (clickOutside)="actionId = null">
                      <button class="button tertiary delete-red" (click)="actionId = 'delete'" [class.disabled]="saving"><i class="im-icon im-icon-trash delete-red icon-l mr-xxxs" style="transform: translateY(-1px);"></i><span>Verwijderen</span></button>
                      <app-confirm-delete (confirm)="delete();" (cancel)="actionId = null" [open]="actionId === 'delete'" positionClass="left" positionClassV="bottom"></app-confirm-delete>
                    </div>
                  }
                  <!-- edit -->
                  @if (true) {
                    <button class="button tertiary ml-xs" (click)="activeSection = 'general'" [class.disabled]="saving"><i class="im-icon im-icon-pencil icon-l mr-xxxs"></i><span>Wijzigen</span></button>
                  }
                </div>
              }
              @if (sectionIsActive('general')) {
                <div class="h-100 d-flex align-items-center">
                  <button class="button tertiary" (click)="canExit() && (id ? activeSection = null : ActiveModal.dismiss()); resetForm()" [class.disabled]="saving"><span>Annuleren</span></button>
                  <app-button classes="primary-default ml-xs" icon="check-round-filled" text="Bewaren" [disabled]="saving" [submitting]="submitting" (emitClick)="createUpdateToolkit()"></app-button>
                </div>
              }
            </div>
            <div class="detail-modal-body">
              <!-- content -->
              <div class="row display-row mw-1200-px">
                <div class="col-xl-12">
                  <!-- Titel -->
                  <div class="display-content">
                    @if (this.activeSection !== 'general') {
                      <div class="display-label" [class.text-color]="sectionIsActive('general')">Titel</div>
                      <div class="display-value d-flex flex-row">
                        <span>{{toolkit.title | display}}</span>
                      </div>
                    }
                    @if (sectionIsActive('general')) {
                      <app-field-text
                        [model]="formSTR.title"
                        (modelChange)="formSTR.title = $event; formChange();"
                        label="Titel"
                        [error]="validation.title"
                        placeholder="Titel"
                        maxWidth="420">
                      </app-field-text>
                    }
                  </div>
                </div>
              </div>
              <!-- Inhoud -->
              <div class="row display-row mw-1200-px">
                <div class="col-md-12">
                  <div class="display-content">
                    @if (this.activeSection !== 'general') {
                      <div class="display-label">Inhoud</div>
                      <div class="display-value d-flex flex-row">
                        <span class="page-content" [innerHTML]="toolkit.content | safe : 'html'"></span>
                      </div>
                    }
                    @if (sectionIsActive('general')) {
                      <app-field-richtext
                        [model]="formSTR.content"
                        (modelChange)="formSTR.content = $event; formChange();"
                        [label]="'Inhoud' | display"
                        [expanded]="true"
                        [error]="validation.content">
                      </app-field-richtext>
                    }
                  </div>
                </div>
              </div>
              <!-- Link -->
              <div class="row display-row mw-1200-px">
                <div class="col-xl-12">
                  <div class="display-content">
                    @if (this.activeSection !== 'general') {
                      <div class="display-label" [class.text-color]="sectionIsActive('general')">Link</div>
                      <div class="display-value d-flex flex-row">
                        @if (toolkit.link) {
                          <a [href]="toolkit.link" target="_blank" class="format-link">{{toolkit.link}}</a>
                        }
                        @if (!toolkit.link) {
                          <span>-</span>
                        }
                      </div>
                    }
                    @if (sectionIsActive('general')) {
                      <app-field-text
                        [model]="formSTR.link"
                        (modelChange)="formSTR.link = $event; formChange();"
                        label="Link"
                        [error]="validation.link"
                        optionalString=""
                        placeholder="Link"
                        maxWidth="420">
                      </app-field-text>
                    }
                  </div>
                </div>
              </div>
              <div class="row display-row mw-1200-px">
                <div class="col-md-5">
                  <!-- Image -->
                  <div class="display-content">
                    @if (this.activeSection !== 'general') {
                      <div class="display-label">Afbeelding</div>
                      <div class="display-value d-flex flex-row">
                        @if (toolkit.imageUrl) {
                          <img [src]="toolkit.imageUrl" alt="toolkitfoto">
                        }
                        @if (!toolkit.imageUrl) {
                          <span>-</span>
                        }
                      </div>
                    }
                    @if (this.activeSection === 'general') {
                      <app-field-image
                        (sendFile)="imageChange($event); formChange();"
                        [label]="'Afbeelding' | display"
                        [url]="toolkit.imageUrl"
                        [error]="validation.image"
                        [optionalString]="'.jpg, .png, .JPEG'">
                      </app-field-image>
                    }
                  </div>
                </div>
              </div>
              <div class="row display-row mw-1200-px" >
                <div class="col-md-2">
                  <!-- published -->
                  <div class="display-content">
                    @if (!sectionIsActive('general')) {
                      <div class="display-label">Gepubliceerd</div>
                      <div class="display-value d-flex flex-row">
                        <span>{{getPublishedText() | display}}</span>
                      </div>
                    }
                    @if (sectionIsActive('general')) {
                      <app-field-radios
                        class="d-block"
                        label="Gepubliceerd"
                        [model]="formSTR.isPublished"
                        (modelChange)="formSTR.isPublished = $event"
                        [error]="validation.isPublished"
                        optionalString=""
                        [options]="[{title: 'Ja', value: 1},{title: 'Nee', value: 2}]"
                        [optionWidth]="80"
                        [optionColumnWidth]="">
                      </app-field-radios>
                    }
                  </div>
                </div>
              </div>
            </div>
            @if (toolkit.id) {
              <div class="detail-modal-footer">
                @if (toolkit.createTS) {
                  <p>Aangemaakt op {{toolkit.createTS | formatTs: 'DD-MM-YYYY'}} @if (toolkit.createBy) {
                    <span>door {{toolkit.createBy}}</span>
                  }</p>
                }
                <p>Gewijzigd op {{toolkit.updateTS | formatTs: 'DD-MM-YYYY'}} @if (toolkit.updateBy) {
                  <span>door {{toolkit.updateBy}}</span>
                }</p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>